var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import "rxjs/add/operator/map";
import "rxjs/add/operator/switchMap";
import { Actions, Effect } from "@ngrx/effects";
import { Observable } from "rxjs/Observable";
import { NotificationsService } from "angular2-notifications";
import { TranslateService } from "@ngx-translate/core";
import { map } from "rxjs/operators/map";
import { catchError } from "rxjs/operators/catchError";
import { UserService } from "@core/store/user/user.service";
import * as UserActions from "./user.actions";
var UserEffects = /** @class */ (function () {
    function UserEffects(actions$, userService, notificationService, translate) {
        var _this = this;
        this.actions$ = actions$;
        this.userService = userService;
        this.notificationService = notificationService;
        this.translate = translate;
        this.load$ = this.actions$
            .ofType(UserActions.ActionTypes.LOAD)
            .switchMap(function () {
            return _this.userService.me().pipe(map(function (_settings) { return new UserActions.LoadUserSuccessAction(_settings); }), catchError(function () { return Observable.of(new UserActions.LoadUserFailAction()); }));
        });
        this.load_success$ = this.actions$
            .ofType(UserActions.ActionTypes.LOAD_SUCCESS)
            .map(function (action) { return action.payload; })
            .do(function (user) {
            var lang = user.settings.language.substring(0, 2);
            _this.translate.use(lang);
        });
    }
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], UserEffects.prototype, "load$", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], UserEffects.prototype, "load_success$", void 0);
    return UserEffects;
}());
export { UserEffects };



// WEBPACK FOOTER //
// /app/src/app/core/store/user/user.effects.ts.pre-build-optimizer.js